import BaseActionTypes from "../../base/BaseActionTypes";

const RESOURCE = "Upload";

const UploadActionTypes = {
  ...BaseActionTypes(RESOURCE),
  UPLOAD_IMAGE: `${RESOURCE}/UPLOAD_IMAGE`,
  SECURE_UPLOAD_IMAGE: `${RESOURCE}/SECURE_UPLOAD_IMAGE`,
};

export default UploadActionTypes;
